import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import { t } from 'translations'

const ButtonLink = ({ href, text, className, active, disabled, icon, light, buttonClass, children, ...props }) => {
  if (typeof buttonClass === 'undefined') buttonClass = light ? 'btn-outline-light' : 'btn-outline-primary'
  const fullClass = `btn ${buttonClass}${active ? ' active' : ''}${className ? ` ${className}` : ''}`

  let content = [typeof text === 'object' ? text : t(text)]

  if (icon) {
    content = (
      <>
        <span className="mr-2 align-middle d-none d-lg-inline">
          <i className={`fad fa-${icon}`} /> {content}
        </span>
        <span className="d-lg-none">
          <i className={`fad fa-${icon}`} />
        </span>
      </>
    )
  }
  // If disabled, just return a normal disabled button
  // This is much simpler than restyling anchors to be disabled
  if (disabled) {
    return (
      <button className={fullClass} disabled {...props}>
        {content}
      </button>
    )
  }

  return (
    <NavLink exact={true} to={href} className={fullClass} {...props}>
      {content}
      {children}
    </NavLink>
  )
}

export default ButtonLink

ButtonLink.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  light: PropTypes.bool,
  buttonClass: PropTypes.string
}
